import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=0aaf8546&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=0aaf8546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf8546",
  null
  
)

export default component.exports